import { OnInit, Component, ViewChild, Output, EventEmitter } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ContactDetailsSession } from "../../../api/models/contactDetailsSession";
import { NotificationDetailsSession } from "../../../api/models/notificationDetailsSession";
import { Contact } from "../../../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../../../pipes/translation.pipe";
import { NotificationDetailsHelperService } from "../../../services/PlacardEditionServices/upplm.notificationDetailsHelper.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";

@Component({
    selector: "editnotificationdetails",
    template: require('./editNotificationDetails.component.html'),
    providers: [NotificationDetailsHelperService],
    styles: ['.container-section-email{padding-left: 0px !important;} #emailTile1{padding-left: 0px}  #emailTile3{padding-left: 0px} #emailTile5{padding-left: 0px} .section-secondary-email{background-color: #fff; border: 2px solid #757575;}']
})

export class EditNotificationDetailsComponent implements OnInit {

    showEditNotificationDetails: boolean = true;
    isLoading: boolean = false;
    showNotificationChanges: boolean = false;
    errors: any[];
    @ViewChild('errorServerMessage', { static: false }) errorServerMessage: UpsDialogComponent;
    @Output() hideEditSection = new EventEmitter<boolean>();
    emailForm: FormGroup;
    email: string;
    primaryEmail: string;
    maxNumberOfEmailsAllowed: number;
    quantityToAdd: number;

    constructor(
        private _storedDataService: StoredDataService,
        private _notificationDetailsHelperService: NotificationDetailsHelperService,
        private _formBuilder: FormBuilder,
        private _translatePipe: TranslateDataPipe
    ) { }

    ngOnInit() {
        this.emailForm = this._formBuilder.group({
            emailRecipients: this._formBuilder.array([])
        });
        this.bindDataFromStoredData(this._storedDataService.notificationDetails, this._storedDataService.contactDetails);
    }

    bindDataFromStoredData(notificationsData: NotificationDetailsSession, contactData: ContactDetailsSession) {

        if (contactData) {
            this.email = contactData.email;
            this.primaryEmail = contactData.makePrimaryContact ? undefined : contactData.primaryEmail;
        }

        this.maxNumberOfEmailsAllowed = contactData && contactData.makePrimaryContact ? 4 : 3;
        this.quantityToAdd = this.maxNumberOfEmailsAllowed == 4 ? 2 : 3;

        if (!contactData.makePrimaryContact && notificationsData.aditionalEmails.length === 4) {
            notificationsData.aditionalEmails.splice(3, 1);
        }

        notificationsData.aditionalEmails.forEach((item) => {
            this.addEmail(item.email);
        });
        
    }

    saveEdit() {
        this.isLoading = true;
        this.displayErrors();

        if (this.errors.length == 0) {
            this.saveEditedDataToRequest();
            this.showNotificationsControl(true);
        }
        this.isLoading = false;
    }

    cancel() {
        this._storedDataService.clearEditingSections();
        this.hideEditSection.emit(true);
    }

    displayErrors() {
        this.errors = [];

        this.emailRecipients.controls.forEach((item:any, idx:number) => {
            
            if (item.controls.contactEmail.value == '') {
                this.errors = this.errors.concat(this.addError(`recipientEmail${idx + this.quantityToAdd}`, `${this._translatePipe.transform('upplm.notificationdetails.email')} ${idx + this.quantityToAdd} ${this._translatePipe.transform('upplm.notificationdetails.isrequiredtext')}`, 'required'));
                item.controls.contactEmail.markAsTouched();
            }
            else if (item.controls.contactEmail.invalid) {
                this.errors = this.errors.concat(this.addError(`recipientEmail${idx + this.quantityToAdd}`, `${this._translatePipe.transform('upplm.notificationdetails.email')} ${idx + this.quantityToAdd} ${this._translatePipe.transform('upplm.notificationdetails.isinvalidtext')}`, 'invalidFormat'));
                item.controls.contactEmail.markAsTouched();
            }
        
        });
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    private saveEditedDataToRequest() {
        this._storedDataService.requestEditedData = this._notificationDetailsHelperService.prepareSaveEditionRequest(this.buildObjectForPrepareRequest());
    }

    private buildObjectForPrepareRequest(): any {

        let contacts: Contact[] = [];

        this.emailRecipients.controls.forEach((item:any) => {
            let contact: Contact = new Contact();
            contact.contactType = '03';
            contact.email = item.controls.contactEmail.value;
            contact.locale = 'en_US';
            contact.name = '';
            contact.phone = '';
            contact.phoneExt = '';
            contacts.push(contact);
        });

        return contacts;
    }

    private showNotificationsControl(show: boolean) {
        this.showEditNotificationDetails = !show;
        this.showNotificationChanges = show;
    }

    hideNotificationChange(showNotificationControl: boolean) {

        this.showNotificationsControl(showNotificationControl);

        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        }
    }

    addEmail(emailAddress: string = undefined) {
        if (this.emailRecipients.length < this.maxNumberOfEmailsAllowed) {
            this.emailRecipients.push(this.newEmailInformArray(emailAddress));
        }
    }

    private newEmailInformArray(emailAddress:string): FormGroup {
        return this._formBuilder.group({
            contactEmail: new FormControl(emailAddress ?? '', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
        })
    }

    removeEmail(position: number) {
        this.emailRecipients.removeAt(position);
    }

    get emailRecipients(): FormArray {
        return this.emailForm.get("emailRecipients") as FormArray
    }
}